// Office UI Fabric React
// Copyright (c) Microsoft Corporation
// All rights reserved.

enum PersonaInitialsColor {
  lightBlue = 0,
  blue = 1,
  darkBlue = 2,
  teal = 3,
  lightGreen = 4,
  green = 5,
  darkGreen = 6,
  lightPink = 7,
  pink = 8,
  magenta = 9,
  purple = 10,
  black = 11,
  orange = 12,
  darkRed = 14,
}

const COLOR_SWATCHES_LOOKUP = [
  PersonaInitialsColor.lightGreen,
  PersonaInitialsColor.lightBlue,
  PersonaInitialsColor.lightPink,
  PersonaInitialsColor.green,
  PersonaInitialsColor.darkGreen,
  PersonaInitialsColor.pink,
  PersonaInitialsColor.magenta,
  PersonaInitialsColor.purple,
  PersonaInitialsColor.black,
  PersonaInitialsColor.teal,
  PersonaInitialsColor.blue,
  PersonaInitialsColor.darkBlue,
  PersonaInitialsColor.orange,
  PersonaInitialsColor.darkRed,
];

const COLOR_SWATCHES_NUM_ENTRIES = COLOR_SWATCHES_LOOKUP.length;

function getInitialsColorFromName(displayName: string): number {
  let color = PersonaInitialsColor.blue;

  let hashCode = 0;
  for (let i = displayName.length - 1; i >= 0; i--) {
    const charCode = displayName.charCodeAt(i);
    const shift = i % 8;

    hashCode ^= (charCode << shift) + (charCode >> (8 - shift));
  }

  color = COLOR_SWATCHES_LOOKUP[hashCode % COLOR_SWATCHES_NUM_ENTRIES];

  return color;
}

function personaInitialsColorToHexCode(personaInitialsColor: number): string {
  switch (personaInitialsColor) {
    case PersonaInitialsColor.lightBlue:
      return '#8AA9FF';
    case PersonaInitialsColor.blue:
      return '#3C70FF';
    case PersonaInitialsColor.darkBlue:
      return '#1E52E0';
    case PersonaInitialsColor.teal:
      return '#23B5D3';
    case PersonaInitialsColor.lightGreen:
      return '#71E5B3';
    case PersonaInitialsColor.green:
      return '#3DDC97';
    case PersonaInitialsColor.darkGreen:
      return '#2DA16E';
    case PersonaInitialsColor.lightPink:
      return '#F7ACCF';
    case PersonaInitialsColor.pink:
      return '#FF006E';
    case PersonaInitialsColor.magenta:
      return '#4C2A85';
    case PersonaInitialsColor.purple:
      return '#7765E3';
    case PersonaInitialsColor.black:
      return '#383d4b';
    case PersonaInitialsColor.orange:
      return '#FF715B';
    case PersonaInitialsColor.darkRed:
      return '#D11149';
    default:
      return '#3C70FF';
  }
}

export default function initialsToColorCode(initials: string): string {
  const initialsColor = getInitialsColorFromName(initials);

  return personaInitialsColorToHexCode(initialsColor);
}
